import { useQuery } from '@tanstack/react-query'
import { getUserUsername } from '@/lib/supabase'

export function useUsername(userId: string | undefined) {
  return useQuery({
    queryKey: ['username', userId],
    queryFn: async () => {
      const username = await getUserUsername(userId!);
      // Keep the query in loading state if username is null or undefined
      if (username === null || username === undefined) {
        throw new Error('Username not found');
      }
      return username;
    },
    enabled: !!userId, // Only run the query if we have a userId
    retry: 3,
    retryDelay: 1000, // Retry after 1 second
  })
}
